
import {
  getShortNoticeCancels,
  updateShortNotice,
  updateDentistCancelled
} from "@/api";
import { currentTimeZone } from "@/helpers";
import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      reveal: false,
      cancels: [] as any,
      cancelsId: 0,
      jobID: null as number | null,
      searchSNCbyIdError: "",
      currentTZ: currentTimeZone()
    };
  },
  methods: {
    async setSNC(): Promise<void> {
      await updateShortNotice({
        id: this.cancelsId,
        change: { NoSNC: 1 }
      });
      this.reveal = false;
      this.getSNC();
    },
    async getSNC(id?: number | null): Promise<void> {
      const condition = id ? id : undefined;
      this.cancels = await getShortNoticeCancels(condition).then(jobs =>
        jobs.map(job => {
          job.shiftDate = format(
            zonedTimeToUtc(job.shiftDate, this.currentTZ),
            "MMMM do yyyy"
          );
          job.beginTimestamp = this.formatDate(job.beginTimestamp);
          job.endTimestamp = this.formatDate(job.endTimestamp);
          job.cancelTimestamp = this.formatDate(job.cancelTimestamp);
          return job;
        })
      );
      if (!this.cancels.length && condition) {
        this.searchSNCbyIdError = "Not found";
      }
    },
    async doneSNC(id: number): Promise<void> {
      await updateDentistCancelled({
        tablename: "DentistCancelled",
        columnname: "ifDone",
        id,
        value: 1,
        prevValue: 0
      });
      this.getSNC();
    },
    formatDate(date: string): string {
      return format(
        utcToZonedTime(date, this.currentTZ),
        "MMMM do yyyy, HH:mm"
      );
    },
    searchSNCbyId() {
      this.getSNC(this.jobID);
    }
  },
  async created() {
    this.getSNC();
  },
  watch: {
    jobID() {
      this.searchSNCbyIdError = "";
    }
  }
});
